// @core/api/endpoints/team/delete_team_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Delete team avatar
 * Permanently deletes a team avatar. If this is the active avatar, a default image will be used instead.
 */
export async function DeleteTeamAvatar(
  team_id: string,
  avatar_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/avatars/:avatar_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
